const Bases = () => {
  return (
    <>
      <h1 className="d-flex justify-content-center">Bases y Condiciones</h1>
      <div
        className="h-50 ml-5 mr-5 d-flex justify-content-center align-items-center"
        style={{ fontSize: 18 }}>
        Deberá seleccionar los requisitos que Ud. cumplimenta como aspirante al concurso,
        considerándose la presente, como Declaración Jurada.
        <br></br>Al efecto, deberá:
        <br></br>* Seleccionar el requisito de nacionalidad requerida como cumplimentado en atención
        a que conforme lo estipulado por el artículo 4° del Convenio Colectivo de Trabajo, el Jefe
        de Gabinete de Ministros podrá exceptuar el cumplimiento del mencionado requisito.
        <br></br>* En oportunidad de encontrarse incluido en las condiciones establecidas en el
        artículo 129 del mencionada Convenio Colectivo, seleccionar el requisito de titulación
        secundaria como cumplimentado, debiendo incluirse en el C.V. electrónico, el compromiso de
        finalización de estudios.
        <br></br>* En oportunidad de encontrarse incluido en las excepciones previstas por el
        artículo 130 del mencionado Convenio Colectivo, seleccionar como cumplimentado el requisito
        de antigüedad requerido por el perfil del puesto a concursar, conforme las condiciones
        descriptas en el mencionado artículo
      </div>
      <div
        className="h-50 ml-5 mr-5 d-flex justify-content-center align-items-center"
        style={{ fontSize: 18 }}>
        Asimismo, la postulación al cargo, implica que Ud. declara bajo juramento:
        <br></br>1. Tener conocimiento de lo dispuesto por la Resolución N° 39/2010 de la entonces
        SECRETARÍA DE GESTIÓN PÚBLICA, sus modificatorias y complementarias, como asimismo aceptar y
        conocer el procedimiento establecido por la mencionada resolución y los alcances que la
        misma tiene dentro del presente proceso.
        <br></br>2. Aceptar y conocer las Bases del Concurso del cargo al que me inscribo en este
        acto; tomando conocimiento del cronograma y metodología de las etapas del proceso, de las
        materias o temáticas a abordar en la(s) prueba(s) y entrevista(s) fijadas, de los puntajes a
        asignar a las diversas características a considerar, el sitio web en la que se divulgarán
        las informaciones y los resultados respectivos, con los cambios que pudiera resolver el
        Comité de Selección y/o el Coordinador Concursal, en caso de corresponder, a los efectos de
        mejor proveer, y que serán comunicados con la antelación suficiente.
        <br></br>3. Que los datos consignados en las solapas “Mi Perfil” y “CV” del sitio web
        CONCURSAR son completos y verdaderos, y que cualquier inexactitud en los datos declarados
        y/o documentados, serán causal suficiente para la exclusión del aspirante/postulante, y que
        los datos consignados son completos, verdaderos y atinentes al perfil del puesto de trabajo
        o función a concursar.
        <br></br>4. Satisfacer los requisitos previstos en los artículos 4° y 5° del Anexo de la Ley
        N° 25.164 y su reglamentación, en los artículos concordantes del CONVENIO COLECTIVO DE
        TRABAJO GENERAL PARA LA ADMINISTRACIÓN PÚBLICA NACIONAL, homologado por el Decreto N°
        214/06, así como aquéllos previstos para el acceso al Agrupamiento y Nivel Escalafonario al
        que se aspira y los establecidos en las Bases del Concurso.
        <br></br>5. Aceptar que las notificaciones a que dé lugar el desarrollo del proceso en el
        que me he inscripto oportunamente puedan ser efectuadas indistintamente en las direcciones
        domiciliaria y electrónica, así como del teléfono que he comunicado en la presente
        inscripción.
        <br></br>6. Reunir los requisitos para acceder al Agrupamiento y Nivel Escalafonario del
        cargo a concursar, previstos por el Sistema Nacional de Empleo Público (Decreto Nº
        2.098/08), y en el caso de ser una convocatoria interna, cumplimentar el requisito general
        de admisión a la Convocatoria Interna para la cobertura de los cargos vacantes asignados
        experiencia laboral acreditable como personal permanente y no permanente según los artículos
        8º y 9º de la Ley N° 25.164 desempeñándose en la actualidad en la Jurisdicción u Organismo
        donde se integrará la vacante convocada.
        <br></br>El/la postulante acepta que la SECRETARÍA DE TRANSFORMACIÓN DEL ESTADO Y FUNCIÓN
        PÚBLICA dependiente del MINISTERIO DE DESREGULACIÓN Y TRANSFORMACIÓN DEL ESTADO DE LA
        NACIÓN, en el marco del concurso en cuestión, realice la gestión correspondiente para la
        tramitación del Certificado de antecedentes penales, ante el Registro Nacional de
        Reincidencia, documentación requerida a los efectos del pertinente procedimiento de
        designación, de conformidad a lo dispuesto en el art. 8 de la Ley 22.117.
      </div>
    </>
  );
};

export default Bases;
